// Module
var code = "<div class=\"block-14__image image\"></div> <div class=\"block-14__large-image image\"></div> ";
// Exports
export default code;